import {Component, OnInit} from '@angular/core';
import {AsyncPipe} from "@angular/common";
import {
  DisplayActiveGameInstanceComponent
} from "../../components/display-active-game-instance/display-active-game-instance.component";
import {HasPermissionDirective} from "../../directives/permissions/has-permission";
import {IGameQueryResult} from "../../interfaces/IGameQueryResult";
import {IActiveGameInstance} from "../../interfaces/IActiveGameInstance";
import {GameInstanceService} from "../../services/game-instance.service";
import {MatDialog} from "@angular/material/dialog";
import {EndGameInstanceComponent} from "../../components/dialogs/end-game-instance/end-game-instance.component";
import {EmailBlastComponent} from "../../components/dialogs/email-blast/email-blast.component";
import {PermissionTypes} from "../../enum/PermissionTypes";
import {
  ColComponent,
  ContainerComponent,
  ListGroupDirective,
  ListGroupItemDirective,
  RowComponent
} from "@coreui/angular";
import {FormsModule} from "@angular/forms";
import {ActiveUserService} from "../../services/active-user.service";
import {UIStateEnum} from "../../enum/UIStateEnum";
import {SnackbarService} from "../../services/snackbar.service";
import {ChooseYourGameComponent} from "../../components/choose-your-game/choose-your-game.component";
import {map, Observable, of, timer} from "rxjs";
import {CountdownService} from "../../services/countdown.service";
import {PipesModule} from "../../pipes/pipes.module";
import {IPauseGame} from "../../interfaces/IPauseGame";
import {MatCard} from "@angular/material/card";
import {PermissionsService} from "../../services/permissions.service";
import {ActiveDrawScreenState} from "../../enum/ActiveDrawScreenState";
import {IPauseGameAfterInstanceEnds} from "../../interfaces/IPauseGameAfterInstanceEnds";
import {GameStateEnum} from "../../enum/GameStateEnum";
import {GameService} from "../../services/game.service";
import {IPauseGameAfterNextWinner} from "../../interfaces/IPauseGameAfterNextWinner";
import {IForceDrawWinner} from "../../interfaces/IForceDrawWinner";
import {GameTypeEnum} from "../../enum/GameTypeEnum";

@Component({
  selector: 'app-cross-game-active-draw-landing',
  standalone: true,
  imports: [
    AsyncPipe,
    DisplayActiveGameInstanceComponent,
    HasPermissionDirective,
    RowComponent,
    ColComponent,
    ContainerComponent,
    FormsModule,
    ChooseYourGameComponent,
    PipesModule,
    MatCard,
    ListGroupDirective,
    ListGroupItemDirective
  ],
  templateUrl: './cross-game-active-draw-landing.component.html',
  styleUrl: './cross-game-active-draw-landing.component.css'
})
export class CrossGameActiveDrawLandingComponent implements OnInit {
  protected readonly permissionTypes = PermissionTypes;
  protected readonly GameStatuses = GameStateEnum;
  protected readonly screenStateEnum = ActiveDrawScreenState;
  public currentScreenState: ActiveDrawScreenState = ActiveDrawScreenState.DrawInfo;
  public chosenGame: IGameQueryResult | null = null;
  public chosenGamesActiveDraw: IActiveGameInstance | null = null;
  public uiState: UIStateEnum = UIStateEnum.ShowLoading;
  public uiStateForTemplate = UIStateEnum;
  public endDateCountDown$: Observable<string> = of('');
  public userHasAnyAdvancedGameSettingsPermissions: boolean = false;

  constructor(private gameInstanceService: GameInstanceService,
              private matDialog: MatDialog,
              private activeUserService: ActiveUserService,
              private countDownService: CountdownService,
              private snackBarService: SnackbarService,
              private permissionsService: PermissionsService,
              private gameService: GameService) {

  }

  ngOnInit() {
    this.userHasAnyAdvancedGameSettingsPermissions = this.checkIfUserHasAnyAdvancedGameSettingsPermissions();
  }

  onGameChange(chosenGame: IGameQueryResult) {
    this.chosenGamesActiveDraw = null;
    this.chosenGame = chosenGame;
    this.uiState = UIStateEnum.ShowLoading;

    this.gameInstanceService.activeGameInstanceByGame(chosenGame.Id, this.activeUserService.activeUser().Id).subscribe({
      next: (activeGameInstanceP: IActiveGameInstance) => {
        this.chosenGamesActiveDraw = activeGameInstanceP;
        this.createCountdownSubscription(new Date(activeGameInstanceP.EndedOn));
        this.uiState = UIStateEnum.ShowData;
      },
      error: (err) => {
        if (err?.Error?.status === 404) {
          this.uiState = UIStateEnum.ShowData;
          this.chosenGamesActiveDraw = null;
          this.snackBarService.openErrorSnackBar('Looks like there is no active game instance for this game');
        } else {
          this.uiState = UIStateEnum.ShowData;
          this.snackBarService.openErrorSnackBar('There was an error retrieving the active game instance for this game. Please try again or contact a system admin');
        }
      }
    })
  }

  private createCountdownSubscription(endDateP: Date): void {
    this.endDateCountDown$ = timer(0, 1000).pipe(map(() => {

      if (endDateP) {
        return this.countDownService.formatRemainingTimeUntilDraw(endDateP);
      }

      return '';
    }));
  }

  openEndGameInstance() {
    this.matDialog.open(EndGameInstanceComponent, {
      data: this.chosenGamesActiveDraw,
      disableClose: true
    })
  }

  openEmailBlast() {
    this.matDialog.open(EmailBlastComponent);
  }

  checkIfUserHasAnyAdvancedGameSettingsPermissions() {
    return (this.permissionsService.userHasCrossGamePermission(PermissionTypes.PauseGameInstance)
    || this.permissionsService.userHasCrossGamePermission(PermissionTypes.SendEmailBlast)
    || this.permissionsService.userHasCrossGamePermission(PermissionTypes.ModifyGameSettings)
    || this.permissionsService.userHasCrossGamePermission(PermissionTypes.ForceDrawWinner));
  }

  protected readonly GameTypeEnum = GameTypeEnum;
}
